import { render, staticRenderFns } from "./OfficesDeliveryAllocationsList.vue?vue&type=template&id=d24b88e8&scoped=true&"
import script from "./OfficesDeliveryAllocationsList.vue?vue&type=script&lang=js&"
export * from "./OfficesDeliveryAllocationsList.vue?vue&type=script&lang=js&"
import style0 from "./OfficesDeliveryAllocationsList.vue?vue&type=style&index=0&id=d24b88e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24b88e8",
  null
  
)

export default component.exports